module.exports = __webpack_public_path__ + "img/10011.a6792d6b.jpg";